import { render, staticRenderFns } from "./UserAnnouncementList.vue?vue&type=template&id=a80aaa5e&scoped=true"
import script from "./UserAnnouncementList.vue?vue&type=script&lang=js"
export * from "./UserAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./UserAnnouncementList.vue?vue&type=style&index=0&id=a80aaa5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80aaa5e",
  null
  
)

export default component.exports